import React, { useMemo } from "react";
import "./CollectionWidget.scss";
import { photoVariant } from "../../utils/imageUrl";

const getPreviewPhoto = (item) => {
  if (!item) return "";

  return (
    item.mainPhoto ||
    (Array.isArray(item.photos) && item.photos[0]) ||
    item.photo ||
    ""
  );
};

const CollectionWidget = ({ collection, onOpen }) => {
  const previewItems = useMemo(() => {
    const source = Array.isArray(collection?.previewItems)
      ? collection.previewItems
      : Array.isArray(collection?.items)
      ? collection.items
      : [];

    const firstFour = source.slice(0, 4).map((item, index) => ({
      id: item?.listingId || item?.id || `collection-preview-${index}`,
      photo: getPreviewPhoto(item),
    }));

    while (firstFour.length < 4) {
      firstFour.push({
        id: `collection-empty-${firstFour.length}`,
        photo: "",
      });
    }

    return firstFour;
  }, [collection]);

  if (!collection) return null;

  return (
    <button
      type="button"
      className="collection-widget"
      onClick={() => onOpen?.(collection)}
      aria-label={`Відкрити добірку ${collection.title || "Добірка"}`}
    >
      <div className="collection-widget__image-wrap">
        <div className="collection-widget__grid">
          {previewItems.map((item, index) => (
            <div key={item.id || index} className="collection-widget__cell">
              {item.photo ? (
                <img
                  src={photoVariant(item.photo, "xs")}
                  alt=""
                  className="collection-widget__image"
                  loading="lazy"
                />
              ) : (
                <div className="collection-widget__placeholder" />
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="collection-widget__body">
        <h3 className="collection-widget__title">
          {collection.title || "Цікава добірка ✨"}
        </h3>
      </div>
    </button>
  );
};

export default CollectionWidget;